module.exports = __webpack_public_path__ + "media/img/event/Sponsor-Ringgit-Plus-3038d2da9adb848f61f04488d5d98547.jpg";